import { FLAG_SPACES } from '@app/feature-flags/flags';
import { useFlags } from '@app/hooks/use-flags';
import {
  selectCurrentSpaceExternalId,
  selectInitialSpaceIdResolved,
} from '@app/routes/organization/selectors';
import { useAppSelector } from '@app/store/store';

export type SpaceContext = {
  spacesEnabled: boolean;
  spaceExternalId: string;
  isSpaceReady: boolean;
};

/**
 * Returns the current space context for the analytics feature.
 *
 * isSpaceReady is false while:
 *  - feature flags haven't loaded yet, OR
 *  - spacesEnabled is true but the initial space id hasn't resolved yet.
 *
 * When spacesEnabled is false the spaceExternalId is always '' so callers can
 * unconditionally spread it into request params without any guard.
 */
export const useSpaceContext = (): SpaceContext => {
  const flags = useFlags();
  const spaceExternalId = useAppSelector(selectCurrentSpaceExternalId);
  const initialSpaceIdResolved = useAppSelector(selectInitialSpaceIdResolved);
  const spacesEnabled = Boolean(flags?.[FLAG_SPACES]);

  return {
    spacesEnabled,
    spaceExternalId: spacesEnabled ? spaceExternalId : '',
    isSpaceReady: flags
      ? !spacesEnabled || (initialSpaceIdResolved && Boolean(spaceExternalId))
      : false,
  };
};
